// Vendor imports
const _ = require('lodash')
const qs = require('qs')
// Client V1 imports
const { track } = require('client/lib/analytics')
const WindowLib = require('client/lib/window')
const Modal = require('client/components/modal')
// Template imports
const articleShareModalTemplate = require('*views/modals/article-share')

const HREF_SELECTOR = '.article-share-modal__href'

function shareArticleHref(article, socialMedium) {
    // const {protocol, hostname, port} = window.location
  // Hard-code production URL scheme; cannot share `localhost` links
  const [protocol, hostname, port] = ['https:', 'mix.com', '']
  return protocol + '//' + hostname + (port ? ':' + port : '') +
    '/!' + article.hash +
    '?' + qs.stringify({
      'utm_source': 'pageview',
      'utm_medium': socialMedium,
      'utm_campaign': 'details_share'
    })
}

function socialShareArticleHref(article, socialMedium) {
  const href = shareArticleHref(article, socialMedium)
  switch (socialMedium) {
    case 'facebook': {
      return '//facebook.com/sharer.php' +
        '?u=' + encodeURIComponent(href)
    }
    case 'twitter': {
      const text = article.title + ' ' + href + ' @getmixapp'
      return '//twitter.com/intent/tweet?lang=en' +
        '&text=' + encodeURIComponent(text)
    }
    case 'pinterest': {
      const media = (
        article.image ||
        article.md5image ||
        wiggin.articlePlaceholder
      )
      return '//pinterest.com/pin/create/button/' +
        '?url=' + encodeURIComponent(href) +
        '&media=' + encodeURIComponent(media)
    }
    case 'email': {
      const subject = 'Check out this article on Mix'
      const body =
        'Heyo, \r\n\r\n' +
        'Check out "' + article.title + '" ' +
        'on Mix at ' + href
      return 'mailto:?subject=' + subject +
        '&body=' + encodeURIComponent(body)
    }
  }
}

const shareWindowSizes = {
  'facebook': [555, 625],
  'twitter': [600, 300],
  'pinterest': [750, 750]
}

module.exports = class ArticleShareModal extends Modal {
  constructor(options) {
    // Handle options
    if (!_.get(options, 'article.hash')) {
      throw Error('Required option `article` is not an Object with `hash` property')
    }
    super(_.defaults(options, {
      modalTemplate: articleShareModalTemplate,
      modalClassName: 'article-share-modal',
      modalTitle: 'Share this post'
    }))
  }

  willRender(templateOptions) {
    const { article } = templateOptions
    const shareHrefs = templateOptions.shareHrefs = {}
    _.each(['facebook', 'twitter', 'pinterest', 'email'], socialMedium => {
      shareHrefs[socialMedium] = socialShareArticleHref(article, socialMedium)
    })
  }

  didRender() {
    // Inherit dismissal listeners
    super.didRender()
    // Add social button listeners
    this.$el.on('click', HREF_SELECTOR, this.openShareWindow.bind(this))
  }

  openShareWindow(event) {
    const $target = $(event.currentTarget)
    const shareType = $target.attr('data-share-type')
    const { article: { 'url_id': urlId } } = this.options
    track('share-external', {
      type: shareType,
      'url_id': urlId,
      metabase: {
        'actioned_object_type': 'url_id',
        'actioned_object_id': urlId,
        'extra_properties': shareType
      }
    })
    if (shareType === 'email') {
      return // Let the browser handle mailto: links
    }
    event.preventDefault()
    const [width, height] = shareWindowSizes[shareType]
    window.open(
      $target.attr('href'),
      `share-${shareType}`,
      WindowLib.centeredWindowFeatures(width, height)
    )
  }

}
